module.exports = __webpack_public_path__ + "img/ebook-mybook.d9704c8f.png";